import { render, staticRenderFns } from "./ConfigBalanceAlert.vue?vue&type=template&id=719f9b34"
import script from "./ConfigBalanceAlert.vue?vue&type=script&lang=ts"
export * from "./ConfigBalanceAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports